import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/authentication.service';
import { CargoSearchAccessService } from 'src/app/modules/cargo/cargo-search/cargo-search-access.service';

@Injectable({ providedIn: 'root' })
export class CargoSearchGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private cargoSearchAccessService: CargoSearchAccessService,
    private router: Router,
  ) { }

  canActivate(): boolean {
    if (this.authService.sessionActive()
      && this.cargoSearchAccessService.showSearchShortcut) {
      return true;
    }
    this.router.navigate(['/home']);
    return false;
  }
}
